import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setOfficeManagementPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useOfficeManagementSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getOfficeManagementSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.office_management_page?.office_management_section}`);
      console.log("🚀 ~ getOfficeManagementSectionJson ~ data:", response);
      console.log("🚀 ~ getOfficeManagementSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setOfficeManagementPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Office Management section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getOfficeManagementSectionJson();
  }, [getOfficeManagementSectionJson]);

  return {
    data,
    loading,
    error,
    getOfficeManagementSectionJson,
    fetchOnMount,
    refetch: getOfficeManagementSectionJson
  };
};

export default useOfficeManagementSection;
